module.exports = __webpack_public_path__ + "img/notazz.9364198a.svg";